/**
 * Token JWT de autorización
 */
import KeyValuePair from '@/modules/core/support/KeyValuePair';

export default class JWTToken {

    private headers = { typ: 'JWT', alg: '' }
    private claims: {[claim: string]: string}
    private valid = false

    constructor (private _token: string) {
        try {
            const [header, claims, signature] = _token.split('.')
            this.headers.alg = JSON.parse(atob(header)).alg
            this.claims = JSON.parse(atob(claims))
            this.valid = true
        } catch (error) {
            if (error instanceof SyntaxError)  {
                this.valid = false
            }

            throw error
        }
    }

    public get encoded (): string {
        return this._token
    }

    public claim (name: string): any  {
        return this.claims[name] || ''
    }

    get isValid (): boolean {
        return this.valid
    }
}

/**
 * Usuario
 */
export class User {
    constructor (private token: JWTToken) {}

    get name (): string {
        return this.token.claim('name')
    }

    get email (): string {
        return this.token.claim('email')
    }

    get id (): number {
        return this.token.claim('sub')
    }
}

export class UnauthorizedError extends Error {
}

/**
 * Usuario activo
 *
 * Lo usuarios activos son aquellos que han iniciado sesión en la aplicación
 * en algún momento. Son mostrados en la pantalla de selección de cuentas.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export class ActiveUser {
    public id = 0
    public name = ''
    public email = ''

    /**
     * Token JWT actual del usuario
     */
    public token = ''

    public serialize () {
        return Object.assign({}, this)
    }

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), data)
    }
}
